import React, { useEffect, useRef } from 'react';

import {
    Box,
    Grid,
    GridItem,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Text,
    Show,
    Heading,
} from '@chakra-ui/react';
import { TableSectionDesktop } from './TableSectionDesktop';
import { TableSectionMobile } from './TableSectionMobile';
import { StyledHeading } from '../TilesSection/styles';

export type SubscriptionInfo = {
    category: string;
    name: string;
    id?: string;
    tooltip?: string;
    isGray?: Boolean;
    values: any;
};

export type TableSectionProps = {
    title: string;
    // valuesName: { [key: string]: string };
    valuesName: any;
    mainCategories: { [key: string]: string };
    tableSection: SubscriptionInfo[];
    tableColumns: Number;
    isOpenAll?: Boolean;
    isBlocked?: {
        base?: Boolean;
        md?: Boolean;
    };
};

function TableSection({
    title,
    tableSection,
    mainCategories,
    valuesName,
    tableColumns,
    isOpenAll,
    isBlocked,
}: TableSectionProps) {
    return (
        <Box>
            {/* <Heading textAlign={'center'} mb={6} as={'h2'} fontWeight={'600'}>
                {title}
            </Heading> */}
            <StyledHeading>{title}</StyledHeading>
            <Box mt={6} width={'100%'} id="subscriptions_table">
                <Show above="lg">
                    <TableSectionDesktop
                        tableSection={tableSection}
                        mainCategories={mainCategories}
                        valuesName={valuesName}
                        columns={tableColumns}
                        isOpenAll={isOpenAll}
                        isBlocked={isBlocked ? isBlocked.md : false}
                    />
                </Show>
                <Show below="lg">
                    <TableSectionMobile
                        tableSection={tableSection}
                        mainCategories={mainCategories}
                        valuesName={valuesName}
                        isOpenAll={isOpenAll}
                    />
                </Show>
            </Box>
        </Box>
    );
}

export default TableSection;
